//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RecurringAttendanceCreateMode } from './Enums';

export class AttendanceInputItem extends ItemBase {
    StudentID: string | null = null;
    Mode: RecurringAttendanceCreateMode = RecurringAttendanceCreateMode.None;

    constructor(initializer?: Partial<AttendanceInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceInputItem";
}
